class PlayerPaymentsController {
	constructor(PaymentsFactory, PlayersFactory, $filter, ngDialog, $stateParams, $state){
		'ngInject';
		const vm = this;

		let $translate = $filter('translate');
		let $date = $filter('date');

		vm.$onInit = () =>{
			vm.playerId = $stateParams.id;
			vm.player = {};
			vm.payments = [];
			PaymentsFactory.getAll().then(response =>{
				vm.payments = response.data;
			});
			let params = {
				include: 'payments'
			};
			PlayersFactory.getOne(vm.playerId, params).then(response =>{
				vm.player = response.data;
				vm.gridOptions.data = response.data.payments;
			});
		};

		vm.gridOptions = {
			paginationPageSizes: [50, 100, 150],
			paginationPageSize: 50,
			enableSorting: true,
			enableColumnMenus: false,
			enableFiltering: true,
			columnDefs: [
				{
					field: 'payment_at',
					enableFiltering: false,
					name: $translate('DATE'),
					width: '130',
				}, {
					field: 'payment.name',
					name: $translate('NAME'),
					enableFiltering: true,
				}, {
					field: 'amount',
					name: $translate('AMOUNT'),
					enableFiltering: true,
					width: '90',
				}, {
					field: 'comments',
					name: $translate('COMMENTS'),
					enableFiltering: true,
				}, {
					field: 'actions',
					enableFiltering: false,
					name: $translate('ACTIONS'),
					headerCellClass: 'text-center',
					cellTemplate: '' +
					'<div ' +
					'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
					'<div class="buttons">' +
					'<button class="btn btn-sm btn-warning" translate ' +
					'data-toggle="modal" ' +
					'data-target="#playerPaymentModal" ' +
					'ng-click="grid.appScope.vm.openEditPlayerPaymentModal(row.entity)">EDIT</button> ' +
					'</div>' +
					'</div>',
					width: '130',
				},
			],
		};

		vm.dateConfig = {startView: 'day', minView: 'day', dropdownSelector: '#dateDropdown'};

		vm.openEditPlayerPaymentModal = (playerPayment) =>{
			vm.playerPayment = {};
			angular.copy(playerPayment, vm.playerPayment);
			vm.playerPayment.status = (vm.playerPayment.status === 1);
		};

		vm.updatePlayerPayment = () =>{
			vm.playerPayment.player_id = vm.playerId;
			vm.playerPayment.payment_at = $date(vm.playerPayment.payment_at, 'yyyy-MM-dd');
			vm.playerPayment.status = vm.playerPayment.status ? 1 : 0;
			if(vm.playerPayment.id){
				PaymentsFactory.updatePayment(vm.playerPayment.id, PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, vm.playerPayment)
							   .then(response =>{
								   ngDialog.open({template: 'successTemplate'});
								   $state.reload();
							   });
			}else{

				PaymentsFactory.addPayment(PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, vm.playerPayment)
							   .then(response =>{
								   ngDialog.open({template: 'successTemplate'});
								   $state.reload();
							   });
			}
		};

		vm.getPlayerPaymentReport = () =>{
			let params = {
				player_id: vm.playerId
			};
			const tabWindowId = window.open('about:blank', '_blank');
			PaymentsFactory.customReport(PaymentsFactory.PAYMENTS_RESOURCES.PLAYER, params).then(response =>{
				let file = new Blob([response.data], {type: 'application/pdf'});
				tabWindowId.location.href = window.URL.createObjectURL(file);
			});
		};
	}
}

export default PlayerPaymentsController;



// WEBPACK FOOTER //
// ./client/app/components/players/playerProfile/playerPayments/playerPayments.controller.js